<!--新建提现记录组件-->
<template>
  <a-modal
    title="新建提现"
    :width="640"
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    class="new-withdrawal-dialog"
    @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="提现金额" prop="withdrawalAmount">
        <a-input
          v-model="ruleForm.withdrawalAmount"
          placeholder="请输入0-1000000数值"
          style="width: 320px"
        />
      </a-form-model-item>

      <a-form-model-item label="上传发票凭证" prop="invoiceAttachment">
        <a-upload
          :action="uploadFileUrl"
          :accept="acceptTypes"
          :file-list="fileList"
          :multiple="true"
          :before-upload="beforeUpload"
          @change="handleUploadChange"
          @remove="handleRemove"
        >
          <a-button>
            <a-icon type="upload"/>
            上传文件
          </a-button>
        </a-upload>
      </a-form-model-item>

      <div class="file-tips">支持扩展名：.png .jpg .jpeg .heic .heif .pdf</div>
    </a-form-model>

    <div class="dialog-footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</a-button>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'NewWithdrawalDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    submitPromise: {
      type: Function,
      default: undefined
    }
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        callback(new Error('请输入提现金额'))
        return
      }
      if (!/^(0|[1-9]\d{0,6})(\.\d{1,2})?$/.test(String(value))) {
        callback(new Error('请输入正确的金额'))
        return
      }
      if (Number(value) > 1000000) {
        callback(new Error('提现金额不能大于1000000'))
        return
      }
      callback()
    }
    const validateVoucher = (rule, value, callback) => {
      if (!value || !value.length) {
        callback(new Error('请上传发票凭证'))
        return
      }
      callback()
    }

    return {
      uploadFileUrl: this.getUploadFileUrl(),
      acceptTypes: '.png,.jpg,.jpeg,.heic,.heif,.pdf',
      fileList: [],
      submitLoading: false,
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      ruleForm: {
        withdrawalAmount: '',
        invoiceAttachment: '',
        invoiceAttachmentList: []
      },
      rules: {
        withdrawalAmount: [
          { required: true, validator: validateAmount, trigger: 'blur' }
        ],
        invoiceAttachment: [
          { required: true, validator: validateVoucher, trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    getUploadFileUrl() {
      const appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    beforeUpload(file) {
      const fileName = file.name || ''
      const suffix = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      const isAccept = ['.png', '.jpg', '.jpeg', '.heic', '.heif', '.pdf'].indexOf(suffix) > -1

      if (!isAccept) {
        this.$message.error('上传文件只能是 png、jpg、jpeg、heic、heif、pdf 格式')
      }

      return isAccept
    },
    handleUploadChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map(file => {
        const url = this.getUploadResponseUrl(file)
        if (url) {
          file.url = url
        }
        return file
      })
      this.fileList = fileList
      this.updateInvoiceAttachment()

      if (info.file.status === 'done') {
        this.updateInvoiceAttachment()
        this.$refs.ruleForm.validateField('invoiceAttachment')
        this.$message.success('上传成功')
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.updateInvoiceAttachment()
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('invoiceAttachment')
      })
    },
    getUploadResponseUrl(file) {
      if (!file) {
        return ''
      }
      if (file.url) {
        return file.url
      }
      const response = file.response
      if (!response) {
        return ''
      }
      if (typeof response === 'string') {
        return response
      }
      if (typeof response.data === 'string') {
        return response.data
      }
      if (response.data && typeof response.data.url === 'string') {
        return response.data.url
      }
      if (typeof response.url === 'string') {
        return response.url
      }
      return ''
    },
    updateInvoiceAttachment() {
      const invoiceAttachmentList = this.fileList
        .filter(file => file.status === 'done' || file.url)
        .map(file => this.getUploadResponseUrl(file))
        .filter(Boolean)

      this.ruleForm.invoiceAttachmentList = invoiceAttachmentList
      this.ruleForm.invoiceAttachment = invoiceAttachmentList.join(',')
    },
    hasUploadingFile() {
      return this.fileList.some(file => {
        return file.status === 'uploading' || (!file.status && !this.getUploadResponseUrl(file))
      })
    },
    checkSubmitParams() {
      this.updateInvoiceAttachment()
      if (this.hasUploadingFile()) {
        this.$message.warning('文件上传中，请稍后再提交')
        return false
      }
      if (!this.ruleForm.withdrawalAmount) {
        this.$message.error('提现金额不能为空')
        return false
      }
      if (!this.ruleForm.invoiceAttachment) {
        this.$message.error('发票凭证不能为空')
        return false
      }
      return true
    },
    getSubmitParams() {
      const withdrawalAmount = String(this.ruleForm.withdrawalAmount).trim()
      const invoiceAttachment = this.ruleForm.invoiceAttachment
      return {
        amount: Number(withdrawalAmount),
        invoiceAttachment
      }
    },
    handleSubmit() {
      if (!this.checkSubmitParams()) {
        return
      }

      this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          return
        }

        if (this.submitPromise) {
          this.submitLoading = true
          this.submitPromise(this.getSubmitParams())
            .then(() => {
              this.$message.success('新建提现成功')
              this.$emit('success')
              this.handleCancel()
            })
            .catch(reason => this.showNetWorkErrorMessage(reason))
            .finally(() => {
              this.submitLoading = false
            })
          return
        }

        this.$emit('submit', this.getSubmitParams())
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    resetForm() {
      this.fileList = []
      this.ruleForm = {
        withdrawalAmount: '',
        invoiceAttachment: '',
        invoiceAttachmentList: []
      }
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.new-withdrawal-dialog {
  /deep/ .ant-modal-body {
    height: 420px;
    padding-top: 32px;
    position: relative;
  }

  .file-tips {
    margin-top: 54px;
    text-align: center;
    color: #999;
  }

  .dialog-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 56px;
    padding: 12px 22px;
    text-align: right;
    border-top: 1px solid #e8e8e8;
    background: #fff;

    .ant-btn + .ant-btn {
      margin-left: 8px;
    }
  }
}
</style>
